// extracted by mini-css-extract-plugin
module.exports =  {"chartWrapper":"ChartBody-module__chartWrapper--tzADr"};